var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hbt-capa'),_c('hbt-frases'),_c('hbt-beneficios'),_c('hbt-turmas-anteriores'),_c('hbt-sobre'),_c('hbt-depoimentos'),_c('hbt-inspiracao'),_c('hbt-inscricao',{attrs:{"endtime":_vm.endtime}}),_c('hbt-cta'),_c('hbt-rodape')],1)}
var staticRenderFns = []

export { render, staticRenderFns }